export default __webpack_public_path__ + "static/media/featuresInfo.92749ce1.svg";